export default value => {
  if(value)
    return value.toFixed(2);
};
